import { render, staticRenderFns } from "./MyGraduationClipSuccessMessage.vue?vue&type=template&id=1039947e"
import script from "./MyGraduationClipSuccessMessage.vue?vue&type=script&lang=js"
export * from "./MyGraduationClipSuccessMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports